import { combineReducers } from 'redux';
import main from './main';
import bundles from './bundles';
import city from './city';
import auth from './auth';

import dealers from './dealers';
import internet from './internet';
import quiz from './quiz';
import feedback from './feedback';
import faq from './faq';
import request from './request';
import routers from './routers';
import tvBoxes from './tvboxes';
import menu from './menu';
import citySelect from './citySelect';
import clientEquipmentInfo from './clientEqipmentInfo';
import plank from './plank';
import news from './news';
import tags from './tags';
import ticket from './ticket';
import tvPackages from './tvPackages';
import intercom from './intercom';
import villageDetail from './vilage-detail';
import wifi from './wifi';
import vas from './vas';
import productsSuspendStateInfo from './productsSuspendStateInfo';
import serviceSettings from '~/src/store/reducers/serviceSettings';
import spas from './spas';
import catalog from './catalog';
import constructorReducer from './constructor';
import { WindowCreator } from '~/src/store/reducers/windowCreateUser';

// Свойства комбинируем в алфавитном порядке
export default combineReducers({
  auth,
  bundles,
  catalog,

  city,
  citySelect,
  clientEquipmentInfo,
  constructor: constructorReducer,
  dealers,
  faq,
  feedback,
  intercom,
  internet,
  main,
  menu,
  news,
  plank,
  productsSuspendStateInfo,
  quiz,
  request,
  routers,
  serviceSettings,
  spas,
  tags,
  ticket,
  tvBoxes,
  tvPackages,
  vas,
  villageDetail,
  wifi,
  WindowCreator,
});
